module.exports = __webpack_public_path__ + "static/media/img_yueyu.d8d63137.png";